<div class="content">
  <div class="container-fluid about">
    <div class="page-title clearfix">
      <h1 class="float-left">
        {{'Smart Power Report' | translate}}
        <small>
          <a [routerLink]="'/help/smart-power-report'" target="_blank">
            <i class="fa fa-question-circle" aria-hidden="true"></i>
          </a>
        </small>
      </h1>
      <!-- <button class="ui-button-danger float-right" type="button" pButton label="{{'Recipent Settings' | translate}}" icon="fa fa-cog" (click)="showReportSetting()" *ngIf="!isMsp"></button>
      <button class="ui-button-danger float-right" type="button" pButton label="{{'Recipent Settings' | translate}}" icon="fa fa-cog" (click)="routeToProAccount()" *ngIf="isMsp"></button> -->
    </div>
    <section>
      <div class="page-filter clearfix multiple-filter">
        <div class="filter-flex">
          <div class="filter">
            <div class="filter-list name_title">
              <div class="filter-content date">
                <p-datepicker [(ngModel)]="filterDate" view="month" dateFormat="mm/yy" [yearNavigator]="true" yearRange="2000:2050" [showIcon]="true"
                            (ngModelChange)="onMonthChange($event)"></p-datepicker>
              </div>
            </div>
            <div class="filter-list name_title" *ngIf="isMsp">
              <div class="filter-content">
                <p-select [options]="regionOption" [(ngModel)]="selectRegion" (onChange)="filterReportList()" [style]="{'width':'100%'}"></p-select>
              </div>
            </div>
            <div class="filter-list">
              <p-selectButton [options]="lastFiveWeeksOptions" [(ngModel)]="lastFiveWeeksValue" (onChange)="handleButtonClick($event)"></p-selectButton>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section style="margin-top: 30px">
      <div class="page-title flex">
        <h5 class="float-left">{{'Weekly Report' | translate}}</h5>
      </div>
      <div class="page-content weekly-report-container">
        <div *ngFor="let week of weekInfoData" class="week-block" [class.selected]="week.weekNumber === selectedWeek">
          <div class="week">
            <div class="th">
              <div class="week-number">WK {{ week.weekNumber }}</div>
            </div>
            <div class="td" (click)="selectWeek(week)" [ngClass]="getCalendarWeekClass(week)">
              <div class="week-date-range">{{ week.startDateStr }} - {{ week.endDateStr }}</div>
              <div class="flex-status">
                <div class="row">
                  <div class="col-md-12">
                    <div class="status-list">
                      <div class="score">{{week.powerProtection}}</div>
                      <div class="txt">{{'Power Threat Blocked' | translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="status-list">
                      <div class="score">
                        {{ week.riskRate === '-' ? '-' : week.riskRate + '%' }}
                      </div>
                      <div class="txt">{{'Time-At-Risk' | translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="status-list">
                      <div class="score">{{week.loadDistribution}}</div>
                      <div class="txt">{{'Load Approaching Peak Capacity' | translate}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section style="margin-top: 30px">
      <div class="page-title flex">
        <h5 class="float-left">{{'Monthly Report' | translate}}</h5>
      </div>
      <div class="page-content monthly-report-container">
        <div *ngFor="let month of monthInfoArray" class="month-block">
          <div class="month">
            <div class="th">
              <div class="week-date-range">{{monthMap[month.month]}}</div>
            </div>
            <div class="td {{month.status}}" (click)="selectMonth(month.month)">
              <div class="flex-status">
                <div class="row">
                  <div class="col-md-12">
                    <div class="status-list">
                      <div class="score">{{month.powerProtection}}</div>
                      <div class="txt">{{'Power Threat Blocked' | translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="status-list">
                      <div class="score">
                        {{ month.riskRate === '-' ? '-' : month.riskRate + '%' }}
                      </div>
                      <div class="txt">{{'Time-At-Risk' | translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="status-list">
                      <div class="score">{{month.loadDistribution}}</div>
                      <div class="txt">{{'Load Approaching Peak Capacity' | translate}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>